(function(){
    "use strict";
    
    angular
        .module("app")
        .component("sideNav", { // side-nav
            templateUrl: "src/app/sideNav/sideNav.html",
            controller: controller
        });

    function controller($window, $location, $analytics, session, CART_TYPE_CODE) {
        const $ctrl = this;
        $ctrl.session = session;
        $ctrl.CART_TYPE_CODE = CART_TYPE_CODE;

        $ctrl.reorderClicked = () => {
            //$window.ga("send", "event", "Reorder", "sideNavReorderClicked");
            $analytics.eventTrack("Click", { category: "Reorder", label: "Left Nav" });
            $location.path(`/orders/`);
        };

        $ctrl.productSelected = (cartTypeCode, classId) => {

            if (cartTypeCode == null) {
                session.products.searchCriteria.cs = false;
                session.products.searchCriteria.classId = classId;
            } else {
                session.products.searchCriteria.cs = cartTypeCode === CART_TYPE_CODE.CSOS;
                session.products.searchCriteria.classId = null;
            }
            
            //session.products.searchCriteria.searchText = "";
            //session.gotoProductSearch();
            //session
            //    .setCartType(cartTypeCode)
            //    .then(() => {
            //        session.products.searchCriteria.searchText = "";
            //        session.gotoProductSearch();
            //    });
        };

        $ctrl.isRxLoc = () => {
            return session.products.searchCriteria.cs === false && session.products.searchCriteria.classId == null;
            //return session.cartTypeCode === CART_TYPE_CODE.RX && !$location.path().contains('product-class') && !$location.path().contains('product-detail');
        };

        $ctrl.isCsLoc = () => {
            return session.products.searchCriteria.cs === true && session.products.searchCriteria.classId == null;
            //return session.cartTypeCode === CART_TYPE_CODE.CSOS && !$location.path().contains('product-class') && !$location.path().contains('product-detail');
        };

        $ctrl.isClassificationLoc = (classId) => {
            return session.products.searchCriteria.cs === false && session.products.searchCriteria.classId === classId;
            //return $location.path().contains(`product-class/${ classification }`);
        };
    }
    controller.$inject = ["$window", "$location", "$analytics", "sessionService", "CART_TYPE_CODE"];
    
})()